<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="ml-2 mr-2">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <h5 class="section-label mb-2 mt-2">
            {{ $t('Setup EasyPay Mandate') }}
          </h5>

          <!-- Table Top -->
          <b-row class="mb-2">

            <!-- Per Page -->
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <TableEntries
                v-model="perPage"
                :options="perPageOptions"
              />
              <Button
                v-if="getUserPermission('MANAGE_TRANFER_GATEWAY_CREDENTIAL')"
                :label="$t('Add')"
                size="md"
                @click="showModal('modal-easypay')"
              />
            </b-col>

            <!-- Search -->
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-lg-end">
                <Button
                  :label="$t('Filter')"
                  size="md"
                  icon="FilterIcon"
                  show-icon
                  class="mr-1"
                  @click="showModal('modal-filter-1')"
                />
                <Button
                  :label="$t('Reset Filter')"
                  size="md"
                  icon="RotateCwIcon"
                  show-icon
                  @click="resetFilter"
                />
              </div>
            </b-col>
          </b-row>

          <b-table
            ref="GatewayConfigsRef"
            :busy="isBusy"
            :per-page="pageSize"
            :current-page="currentPage"
            :items="sortedSettlementGlList"
            responsive
            :fields="translatedTableHeaders"
            primary-key="id"
            show-empty
            :empty-text="$t('No records available')"
            class="position-relative"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner
                  class="align-middle"
                  variant="primary"
                />
              </div>
            </template>
            <template #cell(SN)="data">
              {{ getOverallIndex(data.index) }}
            </template>
            <template #cell(isActive)="data">
              <b-badge
                pill
                :variant="getStatusColor(data.value === true ? 'Active' : 'Inactive')"
              >
                {{ $t(data.value === true ? 'Active' : 'Inactive') }}
              </b-badge>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">

              <div class="text-nowrap">
                <!-- Dropdown -->
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >

                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    @click="onSelectGatewayConfigurationItem(data.item, $event.target, 'view')"
                  >
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50"> {{ $t('View') }} </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="getUserPermission('MANAGE_TRANFER_GATEWAY_CREDENTIAL')"
                    @click="onSelectGatewayConfigurationItem(data.item, $event.target, 'edit')"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50"> {{ $t('Modify') }} </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="getUserPermission('APPLY_EASYPAY_MANDATE') && !(data.item.isActive === true || data.item.isActive === 'Active')"
                    @click="mandateStatus(data.item, $event.target)"
                  >
                    <feather-icon icon="CheckSquareIcon" />
                    <span class="align-middle ml-50">{{ data.item.isActive === true ? $t('Apply Mandate') : $t('Apply Mandate') }}</span>
                  </b-dropdown-item>
                </b-dropdown></div>
            </template>

          </b-table>

          <TablePagination
            v-model="currentPage"
            :from="from"
            :to="to"
            :total-rows="totalEntries"
            :per-page="perPage"
          />

          <!-- modal -->
          <b-modal
            id="modal-easypay"
            ref="my-modal"
            no-close-on-backdrop
            :ok-title="buttonLabel"
            :cancel-title="$t('Cancel')"
            cancel-variant="outline-secondary"
            :ok-disabled="isLoading"
            centered
            size="lg"
            :title="modalTitle"
            @ok="handleSubmit"
            @hidden="resetModal"
          >
            <validation-observer ref="gatewayConfigRules">
              <b-form @submit.prevent="handleSubmit">
                <b-row>
                  <b-col
                    cols="12"
                    class="mb-0 mt-2"
                  />
                </b-row>
                <b-row class="match-height">
                  <!-- EasyPay Biller Id -->
                  <b-col md="6">
                    <InputField
                      id="easyPayBillerId"
                      v-model="easyPayFormData.easyPayBillerId"
                      :label="$t('EasyPay Biller Id')"
                      :placeholder="$t('Enter EasyPay Biller Id- Not more than 4 digits')"
                      :error-name="$t('EasyPay Biller Id')"
                      rules="required"
                      type="number"
                      :is-allow-negative-numbers="false"
                      :max-length="3"
                      for="easyPayBillerId"
                      :readonly="isReadonly"
                    />

                  </b-col>
                  <!-- EasyPay Biller Id -->
                  <!-- EasyPay Mandate Ref -->
                  <b-col md="6">
                    <InputField
                      id="easyPayMandateRef"
                      v-model="easyPayFormData.easyPayMandateRef"
                      :label="$t('EasyPay Mandate Ref')"
                      :placeholder="$t('Easypay Mandate Ref - Not more than 30 characters')"
                      :error-name="$t('EasyPay Mandate Ref')"
                      rules="required"
                      for="easyPayMandateRef"
                      :readonly="isReadonly"
                      type="text"
                      :max-length="29"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Ref -->
                  <!-- EasyPay Mandate Account BVN -->
                  <b-col md="6">
                    <InputField
                      id="easyPayMandateAccountBVN"
                      v-model="easyPayFormData.easyPayMandateAccountBVN"
                      :label="$t('EasyPay Mandate Account BVN')"
                      :placeholder="$t('Enter EasyPay Mandate Account BVN')"
                      type="number"
                      :error-name="$t('EasyPay Mandate Account BVN')"
                      rules="required"
                      for="easyPayMandateAccountBVN"
                      :readonly="isReadonly"
                      :is-allow-negative-numbers="false"
                      :max-length="11"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Account BVN -->
                  <!-- EasyPay Mandate Account Name -->
                  <b-col md="6">
                    <InputField
                      id="outward-transfers-expense-gl"
                      v-model="easyPayFormData.easyPayMandateAccountName"
                      :label="$t('EasyPay Mandate Account Name')"
                      :placeholder="$t('Enter Mandate Account Name')"
                      :error-name="$t('EasyPay Mandate Account Name')"
                      rules="required"
                      for="outward-transfers-expense-gl"
                      :readonly="isReadonly"
                      type="text"
                      :formatter="lettersOnlyFormatter"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Account Name -->
                  <!-- EasyPay Mandate Account Number-->
                  <b-col md="6">
                    <InputField
                      id="easyPayMandateAccountNumber"
                      v-model="easyPayFormData.easyPayMandateAccountNumber"
                      :label="$t('EasyPay Mandate Account Number')"
                      :placeholder="$t('Enter Mandate Account Number')"
                      :error-name="$t('EasyPay Mandate Account Number')"
                      rules="required"
                      for="easyPayMandateAccountNumber"
                      :readonly="isReadonly"
                      type="number"
                      :is-allow-negative-numbers="false"
                      :max-length="9"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Account Number-->

                  <!-- EasyPay Mandate Bank -->
                  <b-col md="6">
                    <SelectField
                      id="easyPayMandateBank"
                      v-model="easyPayFormData.easyPayMandateBank"
                      :label="$t('EasyPay Mandate Bank')"
                      :options="getMandateBankOptions"
                      :error-name="$t('EasyPay Mandate Bank')"
                      rules="required"
                      :reduce="option => option.value"
                      item="label"
                      :placeholder="$t('Select')"
                      :readonly="isReadonly"
                      @input="(val) => handleMandateBankSelect(val)"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Bank -->
                  <!-- EasyPay Mandate Bank NIP Code -->
                  <b-col md="6">
                    <InputField
                      id="easyPayMandateBankNIPCode"
                      v-model="easyPayFormData.easyPayMandateBankNIPCode"
                      :label="$t('EasyPay Mandate Bank NIP Code')"
                      :placeholder="$t('Enter Mandate Bank NIP Code')"
                      :error-name="$t('EasyPay Mandate Bank NIP Code')"
                      rules="required"
                      for="easyPayMandateBankNIPCode"
                      readonly
                      type="number"
                    />
                  </b-col>
                  <!-- EasyPay Mandate Bank NIP Code -->
                </b-row>
              </b-form>
            </validation-observer>

            <template #modal-footer="{ }">
              <b-button
                variant="outline-secondary"
                class="mr-1"
                :disabled="isLoading"
                @click="hideModal('modal-easypay')"
              >
                {{ $t('Cancel') }}
              </b-button>
              <Button
                :label="buttonLabel"
                :loading="isLoading"
                :disabled="isLoading"
                size="md"
                @click="handleSubmit"
              />
            </template>
          </b-modal>
          <!-- modal -->
          <!-- Filter modal -->
          <b-modal
            id="modal-filter-1"
            ref="my-modal"
            :ok-title="$t('Apply')"
            :cancel-title="$t('Cancel')"
            cancel-variant="outline-secondary"
            no-close-on-backdrop
            centered
            size="lg"
            :title="$t('Filters')"
            modal-footer
            @ok="fetchEasyPayConfigurations"
            @cancel="resetFilters"
          >
            <b-row class="match-height">
              <b-col md="6">
                <InputField
                  id="easyPayBillerId"
                  v-model="filter.easyPayBillerId"
                  :label="$t('EasyPay Biller Id')"
                  :placeholder="$t('Enter EasyPay Biller Id')"
                  type="text"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateRef"
                  v-model="filter.easyPayMandateRef"
                  :label="$t('EasyPay Mandate Ref')"
                  :placeholder="$t('Enter EasyPay Mandate Ref')"
                  :error-name="$t('EasyPay Mandate Ref')"
                  type="text"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateAccountBVN"
                  v-model="filter.easyPayMandateAccountBVN"
                  :label="$t('EasyPay Mandate Account BVN')"
                  :placeholder="$t('Enter EasyPay Mandate Account BVN')"
                  :error-name="$t('EasyPay Mandate Account BVN')"
                  type="number"
                  :is-allow-negative-numbers="false"
                  :max-length="11"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateAccountName"
                  v-model="filter.easyPayMandateAccountName"
                  :label="$t('EasyPay Mandate Account Name')"
                  :placeholder="$t('Enter EasyPay Mandate Account Name')"
                  :error-name="$t('EasyPay Mandate Account Name')"
                  type="text"
                  :formatter="lettersOnlyFormatter"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateAccountNumber"
                  v-model="filter.easyPayMandateAccountNumber"
                  :label="$t('EasyPay Mandate Account Number')"
                  :placeholder="$t('Enter EasyPay Mandate Account Number')"
                  :error-name="$t('EasyPay Mandate Account Number')"
                  type="number"
                  :is-allow-negative-numbers="false"
                  :max-length="10"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateBank"
                  v-model="filter.easyPayMandateBank"
                  :label="$t('EasyPay Mandate Bank')"
                  :placeholder="$t('Enter EasyPay Mandate Bank')"
                  :error-name="$t('EasyPay Mandate Bank')"
                  type="text"
                  :formatter="lettersOnlyFormatter"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="easyPayMandateBankNIPCode"
                  v-model="filter.easyPayMandateBankNIPCode"
                  :label="$t('EasyPay Mandate Bank NIP Code')"
                  :placeholder="$t('Enter EasyPay Mandate Bank NIP Code')"
                  :error-name="$t('EasyPay Mandate Bank NIP Code')"
                  type="number"
                  :is-allow-negative-numbers="false"
                  :max-length="10"
                />
              </b-col>
            </b-row>
          </b-modal>
        </b-col>
      </b-row>
    </div>
    <!-- Filter modal -->
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BTable, BSpinner, BModal,
  BForm, BDropdown, BDropdownItem, VBTooltip, BButton, BBadge,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import {
  required, amount, positive,
} from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import TablePagination from '@/views/components/table/TablePagination.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import TableEntries from '@/views/components/table/TableEntries.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import getStatusColor from '../../../../../helpers/getStatusColor'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
    BTable,
    BSpinner,
    BModal,
    BForm,
    BButton,
    ValidationObserver,
    BDropdown,
    BDropdownItem,
    InputField,
    SelectField,
    TablePagination,
    FullScreenSpinner,
    Button,
    TableEntries,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      easyPayConfigurations: [],
      toDateWithYear,
      showSpinner: false,
      isDisabled: false,
      isCustomDisabled: false,
      isLoading: false,
      required,
      amount,
      positive,
      getStatusColor,
      modalTitle: this.$t('EasyPay Mandate Setup'),
      tableHeaders: [
        { key: 'SN', label: 'S/N' },
        { key: 'easyPayMandateBank', sortable: true, label: 'Mandate Bank' },
        { key: 'easyPayMandateRef', sortable: true, label: 'Mandate Ref' },
        { key: 'easyPayMandateAccountBVN', sortable: true, label: 'Mandate Account BVN' },
        { key: 'easyPayMandateAccountName', sortable: true, label: 'Mandate Account Name' },
        { key: 'easyPayMandateAccountNumber', sortable: true, label: 'Mandate Account Number' },
        { key: 'easyPayMandateBank', sortable: true, label: 'Mandate Bank' },
        { key: 'easyPayMandateBankNIPCode', sortable: true, label: 'Mandate Bank NIP Code' },
        { key: 'easyPayBillerId', sortable: true, label: 'Biller Id' },
        { key: 'isActive', sortable: true, label: 'Status' },
        { key: 'actions' },
      ],
      easyPayFormData: {
        easyPayBillerId: '',
        easyPayMandateRef: '',
        easyPayMandateAccountBVN: '',
        easyPayMandateAccountName: '',
        easyPayMandateAccountNumber: '',
        easyPayMandateBank: '',
        easyPayMandateBankNIPCode: '',
      },
      // gatewayProviderOptions: [],
      settlementGlList: [],
      filter: {
        easyPayBillerId: '',
        easyPayMandateRef: '',
        easyPayMandateAccountBVN: '',
        easyPayMandateAccountName: '',
        easyPayMandateAccountNumber: '',
        easyPayMandateBank: '',
        easyPayMandateBankNIPCode: '',
      },
      statusOptions: [
        { label: this.$t('Active'), value: 'Active' },
        { label: this.$t('Inactive'), value: 'Inactive' },
      ],
      getMandateBankOptions: [],
    }
  },
  computed: {
    translatedTableHeaders() {
      return this.tableHeaders.map(header => ({ ...header, label: header.label ? this.$t(header.label) : header.key }))
    },
    sortedSettlementGlList() {
      // Ensure Active (true or 'Active') rows come first
      return [...this.settlementGlList].sort((a, b) => {
        const aActive = a?.isActive === true || a?.isActive === 'Active'
        const bActive = b?.isActive === true || b?.isActive === 'Active'
        return (bActive === true) - (aActive === true)
      })
    },
  },
  watch: {
    currentPage(newValue) {
      this.currentPage = newValue
      this.fetchEasyPayConfigurations()
    },
    perPage(newValue) {
      this.perPage = newValue
      this.fetchEasyPayConfigurations()
    },

  },
  mounted() {
    this.fetchEasyPayConfigurations()
    this.fetchMandateBanks()
  },
  methods: {
    ...mapActions({
      getEasyPayProfile: 'eChannels/getEasyPayProfile',
      createEasyPayProfile: 'eChannels/createEasyPayProfile',
      updateEasyPayProfile: 'eChannels/updateEasyPayProfile',
      updateMandateStatus: 'eChannels/updateMandateStatus',
      getMandateBanks: 'eChannels/getMandateBanks',
    }),
    handleSubmit(bvModalEvt) {
      if (bvModalEvt && typeof bvModalEvt.preventDefault === 'function') {
        bvModalEvt.preventDefault()
      }
      this.$refs.gatewayConfigRules.validate().then(async success => {
        if (success) {
          const areYouSure = this.$t('Are you sure you want to')
          const thisText = this.$t('this EasyPay Mandate')
          const advisory = this.$t('Please, ensure the information you supplied is exactly what the bank has configured. Be careful of pasting from documents as letters can contain hidden special characters.')
          this.confirm(this.gatewayConfigAction, { text: `${areYouSure} ${this.buttonLabel} ${thisText}?\n\n${advisory}` })
        }
      })
    },
    async gatewayConfigAction() {
      try {
        this.isLoading = true
        const formData = {
          ...this.easyPayFormData,
        }
        const response = this.buttonLabel === 'Save'
          ? await this.createEasyPayProfile({ formData, permission: eChannelsPermission.MANAGE_TRANFER_GATEWAY_CREDENTIAL })
          : await this.updateEasyPayProfile({ formData, permission: eChannelsPermission.MANAGE_TRANFER_GATEWAY_CREDENTIAL })

        const { status } = await response
        if (status === 200) {
          this.fetchEasyPayConfigurations()
          this.hideModal('modal-easypay')
          const requestText = this.$t('Your request to')
          const successText = this.$t('EasyPay Mandate was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${successText}` })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('EasyPay Mandate failed. Reason')
          const errorMessage = `${requestText} ${this.buttonLabel} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
      }
    },
    lettersOnlyFormatter(value) {
      if (value === null || value === undefined) return value
      return String(value).replace(/[^A-Za-z\s]/g, '')
    },
    onSelectGatewayConfigurationItem(items, activity, val) {
      try {
        this.isDisabled = val !== 'edit'
        this.isCustomDisabled = val === 'view' || val === 'edit'
        this.easyPayFormData = {
          ...items,
          easyPayBillerId: items.easyPayBillerId || '',
          easyPayMandateRef: items.easyPayMandateRef || '',
          easyPayMandateAccountBVN: items.easyPayMandateAccountBVN || '',
          easyPayMandateAccountName: items.easyPayMandateAccountName || '',
          easyPayMandateAccountNumber: items.easyPayMandateAccountNumber || '',
          easyPayMandateBank: items.easyPayMandateBank || '',
          easyPayMandateBankNIPCode: items.easyPayMandateBankNIPCode || '',
        }
        this.isReadonly = val === 'edit' ? this.isReadonly = false : this.isReadonly = true
        this.modalTitle = val === 'edit' ? this.$t('Edit EasyPay Mandate') : this.$t('View EasyPay Mandate')
        this.buttonLabel = this.$t('Update')
        this.$root.$emit('bv::show::modal', 'modal-easypay')
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    async fetchEasyPayConfigurations() {
      try {
        this.isBusy = true
        this.hideModal('modal-filter-1')
        const response = await this.getEasyPayProfile({
          search: this.filter,
          page: this.currentPage,
          limit: this.perPage,
          permission: eChannelsPermission.MANAGE_TRANFER_GATEWAY_CREDENTIAL,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.settlementGlList = data.data
          this.totalCount = data.recordCount
        } else {
          this.settlementGlList = []
          this.totalCount = 0
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    resetModal() {
      this.easyPayFormData = { ...null }
      this.isReadonly = false
      this.isLoading = false
      this.isDisabled = false
      this.isCustomDisabled = false
      this.modalTitle = this.$t('Create EasyPay Mandate')
      this.buttonLabel = this.$t('Save')
    },
    resetFilters() {
      this.filter = { ...null }
    },
    resetFilter() {
      this.filter = { ...null }
      this.fetchEasyPayConfigurations()
    },

    mandateStatus(items) {
      const { id, isActive } = items

      // Determine the action text (Activate / Deactivate)
      // Use a generic, grammatically correct action verb for messaging
      const action = this.$t('apply')

      // Helper – count how many mandates are currently active
      const activeCount = this.easyPayConfigurations.filter(m => m.isActive).length

      const updateMandateStatus = async () => {
        try {
          this.showSpinner = true

          const response = await this.updateMandateStatus({
            formData: { id },
            permission: eChannelsPermission.APPLY_EASYPAY_MANDATE,
          })

          if (response.status === 200) {
            await this.fetchEasyPayConfigurations() // refresh the list
            const successText = this.$t('Your request to Apply Mandate was successful')
            this.alertSuccess({ text: successText })
          }
        } catch (error) {
          // existing error handling (kept unchanged)
          if (error.response?.data?.errors) {
            error.response.data.errors.forEach(responseError => {
              const requestText = this.$t('Your request to')
              const text1 = this.$t('this Mandate failed. Reason')
              const errorMessage = `${requestText} ${action} ${text1}: ${responseError.errorMessage}`
              this.alertError({ text: errorMessage })
            })
          } else {
            this.alertError({ text: this.$t('An unexpected error occurred.') })
          }
        } finally {
          this.showSpinner = false
        }
      }

      // -----------------------------------------------------------------
      // NEW VALIDATION: only one mandate may be active
      // -----------------------------------------------------------------
      if (isActive) {
        // User wants to **deactivate** the current mandate
        if (activeCount === 1) {
          // This is the *only* active mandate → block deactivation
          const msg = this.$t(
            'You cannot deactivate this mandate because it is the only active one. '
        + 'At least one mandate must remain active.',
          )
          this.alertError({ text: msg })
          return // abort the whole flow
        }
      }

      // -----------------------------------------------------------------
      // Confirmation dialog
      // -----------------------------------------------------------------
      const areYouSure = this.$t('Are you sure you want to')
      const text2 = `${this.$t('this')} ${this.$t('Mandate')}?`
      this.confirm(updateMandateStatus, {
        title: '',
        text: `${areYouSure} ${action} ${text2}`,
      })
    },
    async fetchMandateBanks() {
      try {
        const response = await this.getMandateBanks({
          permission: eChannelsPermission.MANAGE_TRANFER_GATEWAY_CREDENTIAL,
        })
        const { status, data } = response
        if (status === 200 && data.data) {
          this.getMandateBankOptions = data.data.map(item => ({ label: item.name, value: item.nibssCode }))
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isBusy = false
      }
    },
    handleMandateBankSelect(value) {
      this.easyPayFormData.easyPayMandateBankNIPCode = value
    },
  },
}
</script>
